// @flow

import { createGlobalStyle } from 'styled-components';

export default (css: any) => createGlobalStyle`${css}`;
